import { render } from "./UserOptions.vue?vue&type=template&id=40d5fd14&scoped=true"
import script from "./UserOptions.js?vue&type=script&lang=js"
export * from "./UserOptions.js?vue&type=script&lang=js"

import "./UserOptions.scss?vue&type=style&index=0&id=40d5fd14&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d5fd14"]])

export default __exports__